export const ContractsToBeAgreedColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'БИН',
        key: 'bin',
    },
    {
        name: 'Компания',
        key: 'companyName',
        withHint: true,
    },
    {
        name: 'Подписи',
        key: 'signers',
    },
    {
        name: 'Тип договора',
        key: 'type',
    },
    {
        name: 'Почта инициатора',
        key: 'username',
    },
    {
        name: 'Дата отправки',
        key: 'createdAt',
    },
]
